import { FAQ_ACTIONS } from '../../actions/faqActions';

const faqReducer = (state = {
  imageLoaded: 0,
  imagesToBeLoaded: 1,
  faqs: []
}, action) => {
  switch (action.type) {
    case FAQ_ACTIONS.FETCH_DATA:
      state = {
        ...state,
        faqs: action.payload.faqList,
        digitalCode: action.payload.digitalCode
      }
      break;
    case FAQ_ACTIONS.IMAGE_LOADED:
      state = {
        ...state,
        imageLoaded: state.imageLoaded + 1
      }
      break;
    default:
      break;
  }
  return state;
};

export default faqReducer;
